import { render } from "./App.vue?vue&type=template&id=148c6b8e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=148c6b8e&lang=scss"

import exportComponent from "/Volumes/Web/gaisatilts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__